module.exports = __webpack_public_path__ + "media/images/weather/204_night-3ffda3d340c05b518e268023933efda9.png";